export default {
  cancel: '/api/order/cancel',
  exportByNo: '/api/order/export/export_no',
  /** 订单列表 */
  query: '/api/order_query/list',
  /** 地址校验接口 */
  addressVerify: '/api/address/verify',
}
